import { twJoin } from 'tailwind-merge'
import ArrowLeftIcon from '../icons/arrow-left-icon'

export interface CarouselButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  direction: 'left' | 'right'
}

export const CarouselButton: React.FC<CarouselButtonProps> = ({ onClick, direction }) => (
  <div
    className={twJoin(
      'absolute top-1/2 z-30 -translate-y-1/2',
      direction === 'left' ? 'left-2' : 'right-2',
    )}
  >
    <button
      onClick={onClick}
      className="group relative flex size-10 items-center justify-center rounded-full bg-background-secondary shadow-md hover:border-2 hover:border-text-primary"
    >
      <ArrowLeftIcon
        className={twJoin(
          `stroke-brand-primary group-hover:stroke-text-primary`,
          direction === 'right' && 'rotate-180',
        )}
      />
    </button>
  </div>
)
